/**
 * Launcher API client for sending events to central system.
 * Uses HTTP-only cookies for authentication (set by launcher on login)
 */

const LAUNCHER_URL = process.env.REACT_APP_LAUNCHER_URL || 'https://vovan-space.space';
const MISSION_SOURCE = 'earth-globe';

/**
 * Send events to launcher
 * Cookie is sent automatically with credentials: 'include'
 */
export const sendEvents = async (events) => {
  if (!events || events.length === 0) {
    return null;
  }

  try {
    const response = await fetch(`${LAUNCHER_URL}/api/events`, {
      method: 'POST',
      credentials: 'include', // Send cookies cross-origin
      headers: {
        'Content-Type': 'application/json',
        'X-Mission-Source': MISSION_SOURCE,
      },
      body: JSON.stringify({ events }),
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Failed to send events to launcher:', error.message);
    return null;
  }
};

/**
 * Send country viewed event
 */
export const sendCountryViewed = async (countryData) => {
  const events = [
    {
      type: 'country_viewed',
      data: countryData,
      points: 0,
      timestamp: new Date().toISOString(),
    }
  ];

  return sendEvents(events);
};

/**
 * Fetch user profile from launcher
 * Cookie is sent automatically with credentials: 'include'
 */
export const fetchProfile = async () => {
  try {
    const response = await fetch(`${LAUNCHER_URL}/api/profile`, {
      method: 'GET',
      credentials: 'include', // Send cookies cross-origin
      headers: {
        'X-Mission-Source': MISSION_SOURCE,
      },
    });

    if (!response.ok) {
      return null;
    }

    return await response.json();
  } catch (error) {
    console.error('Failed to fetch profile:', error.message);
    return null;
  }
};

/**
 * Get launcher URL for navigation
 */
export const getLauncherUrl = () => LAUNCHER_URL;

/**
 * @deprecated Use cookies now - kept for backward compatibility
 */
export const getSessionToken = () => {
  // Clean URL if token present (legacy support)
  const urlParams = new URLSearchParams(window.location.search);
  const urlToken = urlParams.get('token');
  if (urlToken) {
    const url = new URL(window.location.href);
    url.searchParams.delete('token');
    window.history.replaceState({}, '', url.toString());
  }
  return null; // Cookies handle auth now
};

export default {
  sendEvents,
  sendCountryViewed,
  fetchProfile,
  getSessionToken,
  getLauncherUrl,
};
